import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { Button, Tooltip } from '@salesforce/design-system-react';

import './EthicalScan.scss';

class EthicalScan extends React.Component {
  handleLearnMore = e => {
    const learnMoreLink =
      'https://help.salesforce.com/articleView?id=mc_pb_manage_einstein_content_selection_attributes_and_bias.htm&type=5';
    window.open(learnMoreLink, '_blank', 'noopener noreferrer');
  };

  isAttrScanValid(scanResult) {
    return (
      scanResult.status !== undefined &&
      scanResult.status !== 'ERROR' &&
      scanResult.status !== 'OK'
    );
  }

  render() {
    const { formatMessage } = this.props.intl;

    if (this.isAttrScanValid(this.props)) {
      return (
        <div className="ethical-scan">
          <Tooltip
            align="bottom left"
            className="slds-text-align_left ethical-scan-popover"
            content={formatMessage({
              id: 'common.ethical.warning'
            })}
            ariaLabelledby={`popover-${this.props.attribute}`.replace(' ', '_')}
            hasAnchoredNubbin={true}
            hasStaticAlignment={true}
          >
            <Button
              assistiveText={{ icon: 'Warning' }}
              iconCategory="utility"
              iconName="shield"
              iconSize="medium"
              variant="icon"
              onClick={this.handleLearnMore}
            />
          </Tooltip>
        </div>
      );
    } else {
      return null;
    }
  }
}

EthicalScan.propTypes = {
  attribute: PropTypes.string,
  completed: PropTypes.bool,
  status: PropTypes.string,
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ),
  intl: intlShape.isRequired
};

export default injectIntl(EthicalScan);
